module.exports = __webpack_public_path__ + "static/media/LoginLogo.b000329a.png";